import { Component, TemplateRef, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
    selector: 'eui-tab-label, euiTabLabel',
    template: `<ng-template #euiTabLabel><ng-content></ng-content></ng-template>`,
})
export class EuiTabLabelComponent implements AfterViewInit {

    @ViewChild('euiTabLabel') templateRef: TemplateRef<any>;

    private templatePortal: TemplatePortal<any>;

    constructor(private viewContainerRef: ViewContainerRef) {
    }

    ngAfterViewInit(): void {
        this.templatePortal = new TemplatePortal(this.templateRef, this.viewContainerRef);
    }
}
